export const normaliseRoute = (route: string): string => {
  const [routeWithoutQuery = ''] = route.split('?');
  return routeWithoutQuery.replace(/^#/, '').replace(/\/$/, '') || '/';
};
